import Icon from 'vue-awesome/components/Icon'

Icon.register({
  compass_calibration_sharp: {
    raw: '<path fill="none" d="M0 0h24v24H0V0z"/><circle cx="12" cy="17" r="4"/><path d="M12 3C8.1 3 4.56 4.59 2 7.15l5 5a7.06 7.06 0 0110-.01l5-5C19.44 4.59 15.9 3 12 3z"/>',
    width: '24',
    height: '24'
  }
})
